export class PlaceViewModel {

    id: number;
    caption: string;
    type: number;
    fullAddress: string;
    description: string;
    detail: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    country: string;
    note: string;
    imageId: number;
    mediaType: number;
    mediaUrl: string;
    originalMediaUrl: string;
    tag: string;
    place: string;
    fileName: string;    
}